import {
  RadioGroup,
  SimpleGrid,
  Flex,
  Box,
  Radio,
  Input
} from "@chakra-ui/react";
import useScreenType from "react-screentype-hook";

type Props = {
  options: { label: string; value: string; disabled?: boolean }[];
  formik: any;
  notListedFieldName?: string;
  name: string;
  isDisabled?: boolean;
  onChange?: (val?: any) => void;
  value?: string;
};

const RadioButtonGroup: React.FC<Props> = ({
  options,
  formik,
  notListedFieldName,
  name,
  isDisabled,
  onChange,
  value,
}) => {

  const { isMobile } = useScreenType();
  
  return(
  <RadioGroup
    isDisabled={isDisabled}
    onChange={(val) => {
      if (onChange) {
        onChange(val);
      } else {
        formik.setFieldValue(name, val);
        if (notListedFieldName) {
          formik.setFieldValue(notListedFieldName, "");
        }
      }
    }}
    value={value || formik.values[name]}
    name={name}
  >
    <SimpleGrid columns={ isMobile ? [1] : [2]} spacingX="44px">
      {options.map((option) =>
        option.value === "not-listed" && notListedFieldName ? (
          <Box key={option.value} mb="24px" className="not-listed-field">
            <Flex minWidth="max-content" flexDirection={'row'} alignItems={isMobile ? "start" : "center"}  gap="2">
              <Box>
                <Radio
                  key="not-listed"
                  value="not-listed"
                  colorScheme="primary"
                  data-cy={`radio-${option.value}`}
                >
                  Not listed:
                </Radio>
              </Box>

              <Box flexGrow={1}>
                <Input
                  isDisabled={formik.values[name] != "not-listed"}
                  value={formik.values[notListedFieldName]}
                  onChange={(val) =>
                    formik.setFieldValue(notListedFieldName, val.target.value)
                  }
                  name={notListedFieldName}
                  className="flushed"
                  {...{ maxLength: 50 }}
                />
              </Box>
            </Flex>
            {notListedFieldName && (
              <p style={{ color: "red" }}>
                {formik.errors[notListedFieldName]}
              </p>
            )}
          </Box>
        ) : (
          <Box key={option.value} mb="10px">
            <Radio
              key={option.value}
              value={option.value}
              colorScheme="primary"
              data-cy={`radio-${option.value}`}
            >
              {option.label}
            </Radio>
          </Box>
        )
      )}
    </SimpleGrid>
  </RadioGroup>
)};

export default RadioButtonGroup;
